import React from "react"
import PropTypes from "prop-types"
import Authenticated from "../../../lib/Authenticated"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { Button, ButtonGroup, Col, Row } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import AlertModal from "../../fragments/AlertModal"
import WalletAddress from "../../fragments/WalletAddress"
import CreatedOnDate from "../../fragments/CreatedOnDate"
import { CardType } from "../../../lib/utils"
import { browserHistory } from "react-router"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import RenderPayments from "./RenderPayment"

class InvestorCard extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    shouldDelete: false,
    showFullWallet: false,
    running: false,
    success: false,
    error: null,
  }

  handleDelete = () => this.setState({
    shouldDelete: true,
    running: false,
    success: false,
    error: null
  })

  closeDeleteForm = () => this.setState({ shouldDelete: false })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { investor: { id: investorId }, removeInvestor, cardType } = this.props

    blockingFetchService(
      accessToken => apiServerApi.deleteInvestor(accessToken, investorId),
      _ => {

        this.setState({ success: true })
        setTimeout(() => {

          this.closeDeleteForm()
          removeInvestor(investorId)

          if (cardType === CardType.LARGE) {
            browserHistory.push('/financiers/investors')
          }
        }, 800)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state,
    { investor } = this.props

    return !!investor && (
      <div>
        <h3>Are you sure you want to delete &#171; { investor.name } &#187;?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderBtnGroup = (id, isLarge) => (
    <ButtonGroup justified>

      <Button href='#' bsStyle='success' disabled={ !this.isAdmin }
        onClick={() => browserHistory.push(`/financiers/investors/${id}/update`)}>
        <FontAwesome name='pencil' /> Update
      </Button>

      <Button href='#' bsStyle='warning' disabled={ !this.isAdmin }
        onClick={ this.handleDelete } title='Delete'>
        <FontAwesome name='trash-o' /> Delete
      </Button>

      { isLarge &&
      <Button href='#' onClick={() => browserHistory.push('/financiers/investors/create') }>
        <FontAwesome name='plus-circle' /> Add Investor
      </Button>}
    </ButtonGroup>
  )

  showItem = () => {

    const { investor, cardType } = this.props,

    { id, name, bankName, walletAddress, createdOn, payments } = investor,

    { showFullWallet } = this.state,

    isLarge = cardType === CardType.LARGE

    return (
      <div className='detail-content'>

        { this.renderBtnGroup(id, isLarge) }

        <h2 className='blue mt-20'>{ name }</h2>

        <SimpleCardRow name='Bank name' value={ bankName ? bankName : '-' }
          title='Bank name' />

        <SimpleCardRow name='Wallet address' title='Wallet address'
          value={ <WalletAddress address={ walletAddress } shouldShow={ showFullWallet }
            onClick={() => this.setState({ showFullWallet: !showFullWallet })} />} 
        />

        <RenderPayments payments={ payments } />

        <hr/>
        <CreatedOnDate createdOn={ createdOn } />
      </div>
    )
  }

  renderLargeCard = () => {

    const breadCrumbData = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/investors', title: 'Investors' }
    ],

    { investor: { name } } = this.props

    return (
      <div>
        <CustomBreadCrumb activeText={ name } data={ breadCrumbData } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="fire" size="3x" className="detail-icon" />
          </Col>

          <Col md={8}>
            { this.showItem() }
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    const { cardType } = this.props,
    { shouldDelete, running } = this.state

    return (
      <div>

        { cardType === CardType.SMALL ? this.showItem() : this.renderLargeCard() }

        <AlertModal
          show={ shouldDelete }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

InvestorCard.propTypes = {
  investor: PropTypes.object.isRequired,
  cardType: PropTypes.string.isRequired,
}

export default InvestorCard



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Card.js